<template>
    <div>
        <AdminPageHeader title="Gastos" description="Registro de gastos y sus catálogos de apoyo.">
            <template #tabs>
                <AdmTabs :model-value="actualPageView" :tabs="viewTabs" label="Secciones de gastos" @update:model-value="setView" />
            </template>
        </AdminPageHeader>

        <div class="gastos__layout">
            <!-- ---------------- Formulario según la pestaña activa ---------------- -->
            <AdmCard :title="formTitle" class="gastos__form-card">
                <form v-show="category" class="gastos__form" @submit.prevent="submitForm">
                    <AdmField v-model="categoryData.name" label="Nombre de la categoría" required />
                    <AdmField v-model="categoryData.code" label="Código" />
                    <AdmField v-model="categoryData.info" label="Información adicional" />
                    <div class="gastos__form-actions">
                        <AdmButton variant="ghost" @click="cancel()">Cancelar</AdmButton>
                        <AdmButton type="submit">{{ edit ? 'Guardar cambios' : 'Enviar' }}</AdmButton>
                    </div>
                </form>

                <form v-show="cajaView" class="gastos__form" @submit.prevent="submitForm">
                    <AdmField v-model="cajaData.name" label="Nombre de la caja" required />
                    <AdmField v-model="cajaData.code" label="Código" />
                    <AdmField v-model="cajaData.info" label="Información adicional" />
                    <div class="gastos__form-actions">
                        <AdmButton variant="ghost" @click="cancel()">Cancelar</AdmButton>
                        <AdmButton type="submit">{{ edit ? 'Guardar cambios' : 'Enviar' }}</AdmButton>
                    </div>
                </form>

                <form v-show="proveedor" class="gastos__form" @submit.prevent="submitForm">
                    <AdmField v-model="proveedorData.name" label="Nombre del proveedor" required />
                    <AdmField v-model="proveedorData.type" label="Tipo" type="select" required>
                        <option disabled value="">Seleccione un tipo</option>
                        <option>Persona Natural</option>
                        <option>Persona Jurídica</option>
                        <option>Entidad Pública</option>
                        <option>Entidad sin Ánimo de Lucro</option>
                        <option>Extranjero</option>
                    </AdmField>
                    <div class="gastos__multi">
                        <span class="gastos__multi-label">Roles del tercero</span>
                        <multiselect
                            v-model="actualLabel"
                            :options="options"
                            :multiple="true"
                            placeholder="Selecciona roles"
                            label="name"
                            track-by="value"
                            :close-on-select="true"
                        />
                    </div>
                    <AdmField v-model="proveedorData.NumberId" label="Número de identificación" required />
                    <AdmField v-model="proveedorData.Direction" label="Dirección" />
                    <AdmField v-model="proveedorData.email" label="Correo electrónico" type="email" />
                    <AdmField v-model="proveedorData.phone" label="Teléfono" />
                    <AdmField v-model="proveedorData.info" label="Información adicional" />
                    <div class="gastos__form-actions">
                        <AdmButton variant="ghost" @click="cancel()">Cancelar</AdmButton>
                        <AdmButton type="submit">{{ edit ? 'Guardar cambios' : 'Enviar' }}</AdmButton>
                    </div>
                </form>

                <form v-show="gastos" class="gastos__form" @submit.prevent="submitForm">
                    <AdmField v-model="gastosData.name" label="Nombre del gasto" required />
                    <AdmField v-model="gastosData.proveedor" label="Proveedor" type="select" required>
                        <option disabled value="">Seleccione un proveedor</option>
                        <option v-for="prov in availableThirdParties" :key="prov.id" :value="prov.id">
                            {{ prov.name }}
                        </option>
                    </AdmField>
                    <AdmField v-model="gastosData.cajaId" label="Caja" type="select">
                        <option v-for="caja in availableCajas" :key="caja.id" :value="caja.id">
                            {{ caja.name }}{{ caja.isDefault ? ' (por defecto)' : '' }}
                        </option>
                    </AdmField>
                    <AdmField v-model="gastosData.date" label="Fecha" type="date" required />

                    <div class="gastos__items">
                        <span class="adm-section-label">Ítems del gasto</span>
                        <div v-for="(item, index) in gastosData.items" :key="index" class="gastos__item-row">
                            <itemCalculate
                                :id="index"
                                v-model:category="item.category"
                                v-model:price="item.price"
                                v-model:base="item.base"
                                v-model:ivaAdded="item.ivaAdded"
                                v-model:iva="item.taxData.iva"
                                v-model:reteFuente="item.taxData.reteFuente"
                                v-model:reteIca="item.taxData.reteIca"
                                v-model:amount="item.amount"
                                :availableItems="availableCategories"
                                @update:valores="valor = $event"
                            />
                            <AdmButton
                                variant="danger"
                                size="sm"
                                :icon="X"
                                :disabled="gastosData.items.length === 1"
                                title="Eliminar ítem"
                                @click="gastosData.items.splice(index, 1)"
                            />
                        </div>
                        <AdmButton variant="secondary" size="sm" :icon="Plus" @click="additem()">
                            Adicionar ítem
                        </AdmButton>
                    </div>

                    <p class="gastos__total"><span>Valor total:</span> <strong>{{ valorTotal }}</strong></p>

                    <AdmField v-model="gastosData.info" label="Información adicional" />

                    <div class="gastos__form-actions">
                        <AdmButton variant="ghost" @click="cancel()">Cancelar</AdmButton>
                        <AdmButton type="submit">{{ edit ? 'Guardar cambios' : 'Enviar' }}</AdmButton>
                    </div>
                </form>
            </AdmCard>

            <!-- ---------------- Listado ---------------- -->
            <div class="adm-stack">
                <AdmCard title="Buscar">
                    <div class="gastos__filter-row">
                        <AdmField v-model="filter.name" label="Nombre" placeholder="Filtrar por nombre" />
                        <AdmField v-model="filter.id" label="ID" type="number" :step="1" :min="1" placeholder="Filtrar por id" />
                        <div class="gastos__filter-toggle">
                            <AdmButton
                                v-show="actualPageView === 'gastos'"
                                variant="secondary"
                                @click="showAdvancedFilters = !showAdvancedFilters"
                            >
                                Más filtros
                                <AdmBadge v-if="activeAdvancedCount > 0" tone="info" :label="String(activeAdvancedCount)" />
                                <component :is="showAdvancedFilters ? ChevronUp : ChevronDown" :size="15" />
                            </AdmButton>
                        </div>
                    </div>

                    <div v-show="actualPageView === 'gastos' && showAdvancedFilters" class="gastos__filter-row gastos__filter-row--advanced">
                        <AdmField v-model="filter.thirdPartiesID" label="Proveedor" type="select">
                            <option value="">Todos los proveedores</option>
                            <option v-for="prov in availableThirdParties" :key="prov.id" :value="prov.id">
                                {{ prov.name }}
                            </option>
                        </AdmField>
                        <AdmField v-model="filter.cajaId" label="Caja" type="select">
                            <option value="">Todas las cajas</option>
                            <option v-for="caja in availableCajas" :key="caja.id" :value="caja.id">
                                {{ caja.name }}
                            </option>
                        </AdmField>
                        <AdmField v-model="filter.dateFrom" label="Desde" type="date" />
                        <AdmField v-model="filter.dateTo" label="Hasta" type="date" />
                    </div>
                </AdmCard>

                <AdmCard title="Registros">
                    <div class="gastos__list">
                        <article v-for="item in actualItems" :key="item.id" class="gastos__card">
                            <div class="gastos__card-body">
                                <header class="gastos__card-head">
                                    <span class="gastos__card-id">#{{ item.id }}</span>
                                    <h3 class="gastos__card-name">{{ item.name }}</h3>
                                    <AdmBadge
                                        :tone="item.status ? 'ok' : 'neutral'"
                                        :label="item.status ? 'Activo' : 'Inactivo'"
                                    />
                                </header>

                                <p v-if="item.info" class="adm-muted gastos__card-info">{{ item.info }}</p>

                                <dl v-if="actualPageView === 'gastos'" class="gastos__card-meta">
                                    <div>
                                        <dt>Proveedor</dt>
                                        <dd>{{ item.thirdPartyName || '—' }}</dd>
                                    </div>
                                    <div>
                                        <dt>Caja</dt>
                                        <dd>{{ item.cajaName || 'Por defecto' }}</dd>
                                    </div>
                                    <div>
                                        <dt>Fecha</dt>
                                        <dd>{{ formatDate(item.dateAt) }}</dd>
                                    </div>
                                    <div>
                                        <dt>Total</dt>
                                        <dd class="gastos__card-total">{{ formatTotal(item.total) }}</dd>
                                    </div>
                                </dl>
                            </div>

                            <AdmButton
                                variant="secondary"
                                size="sm"
                                :icon="Pencil"
                                title="Editar"
                                @click.prevent="fetchById(item.id)"
                            />
                        </article>

                        <AdmEmptyState
                            v-if="!actualItems.length"
                            message="No hay resultados con los filtros actuales."
                        />
                    </div>

                    <template #footer>
                        <AdmPagination :page="page" :total-pages="totalPages || 1" @update:page="goToPage" />
                    </template>
                </AdmCard>
            </div>
        </div>
    </div>
</template>

<script>
import { getItems, saveData, getItemsById, editData } from '@/services/dbGastos.js'
import itemCalculate from './itemCalculate.vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'
import { formatCurrencyRAE } from '@/utils/numberFormat'
import { Pencil, Plus, X, ChevronUp, ChevronDown } from 'lucide-vue-next'
import AdminPageHeader from '@/components/Admin/AdminPageHeader.vue'
import AdmCard from '@/components/Admin/ui/AdmCard.vue'
import AdmField from '@/components/Admin/ui/AdmField.vue'
import AdmButton from '@/components/Admin/ui/AdmButton.vue'
import AdmBadge from '@/components/Admin/ui/AdmBadge.vue'
import AdmTabs from '@/components/Admin/ui/AdmTabs.vue'
import AdmPagination from '@/components/Admin/ui/AdmPagination.vue'
import AdmEmptyState from '@/components/Admin/ui/AdmEmptyState.vue'
import { notify } from '@/composables/useAdmToast.js'

function formatDateShort(value) {
    if (!value) return '—';
    const d = new Date(value);
    if (isNaN(d.getTime())) return '—';
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${dd}/${mm}/${yyyy}`;
}

    export default {
        name: 'gastosPage',
        data() {
            return {
                Pencil,
                Plus,
                X,
                ChevronUp,
                ChevronDown,
                // Las cuatro sub-vistas que antes eran botones sueltos con
                // `.button--active`; ahora son pestanas con semantica de tab.
                viewTabs: [
                    { value: 'gastos', label: 'Gastos' },
                    { value: 'thirdParties', label: 'Proveedores' },
                    { value: 'categorias', label: 'Categorías' },
                    { value: 'cajas', label: 'Cajas' },
                ],
                category: false,
                cajaView: false,
                proveedor: false,
                gastos: true,
                edit:false,
                actualPageView: 'gastos',
                actualId: "",
                categoryData: {
                    name: "",
                    code: "",
                    info: ""
                },
                cajaData: {
                    name: "",
                    code: "",
                    info: ""
                },
                proveedorData: {
                    name: "",
                    type: "",
                    label: [""],
                    NumberId: "",
                    Direction: "",
                    email: "",
                    phone: "",
                    info: ""
                },
                gastosData: {
                    name: "",
                    proveedor: "",
                    cajaId: "",
                    date: this.getFechaHoy(),
                    items: [{
                        id: "",
                        category: "",
                        price: "",
                        base: "",
                        ivaAdded:"",
                        taxData: {
                            iva: "",
                            reteFuente: "",
                            reteIca: ""
                            },
                        amount: "",
                        }],
                    info: ""
                },
                filter: {
                    name: "",
                    id: "",
                    label: "",
                    thirdPartiesID: "",
                    cajaId: "",
                    dateFrom: "",
                    dateTo: ""
                },
                page: 1,
                limit: 7,
                totalPages: 2,
                actualItems: [],
                availableCategories: [],
                availableThirdParties: [],
                availableCajas: [],
                defaultCajaId: "",
                debounceTimer: null,
                cards: 1,
                showAdvancedFilters: false,
                actualLabel: [],
                options: [
                { name: 'Cliente', value: 'cliente' },
                { name: 'Proveedor', value: 'proveedor' },
                { name: 'Paciente', value: 'paciente' },
                { name: 'Empleado', value: 'empleado' },
                { name: 'Asesor', value: 'asesor' },
                { name: 'Técnico', value: 'tecnico' },
                { name: 'Administrador', value: 'administrador' },
                { name: 'Otro', value: 'otro' }
                ]
            }
        },
        components: {
            itemCalculate,
            Multiselect,
            AdminPageHeader,
            AdmCard,
            AdmField,
            AdmButton,
            AdmBadge,
            AdmTabs,
            AdmPagination,
            AdmEmptyState,
        },
        watch: {
            filter: {
                deep: true,
                handler() {
                    clearTimeout(this.debounceTimer)
                    this.debounceTimer = setTimeout(() => {
                    this.page = 1
                    this.fetchItems()
                    }, 400)
                }
            },

        },
        computed: {
                formTitle() {
                    const base = {
                        gastos: 'gasto',
                        thirdParties: 'proveedor',
                        categorias: 'categoría',
                        cajas: 'caja',
                    }[this.actualPageView] || 'registro';
                    return this.edit ? `Editando ${base} #${this.actualId}` : `Nuevo ${base}`;
                },
                activeAdvancedCount() {
                    let n = 0;
                    if (this.filter.thirdPartiesID) n++;
                    if (this.filter.dateFrom) n++;
                    if (this.filter.dateTo) n++;
                    return n;
                },
                valorTotal() {
                    let total = 0
                    for(const item of this.gastosData.items){
                        const base = parseFloat(item.base) || 0;
                        const iva = parseFloat(item.taxData?.iva) || 0;
                        const reteFuente = parseFloat(item.taxData?.reteFuente) || 0;
                        const reteIca = parseFloat(item.taxData?.reteIca) || 0;
                        const amount = parseFloat(item.amount) || 0;

                        const totalItem= (base*(1+(iva-reteFuente-reteIca)/100)) * amount
                        total += totalItem || 0
                    }
                    return formatCurrencyRAE(total)
                }
        },
        methods: {
            validateData(data){
                if (!data.proveedor || data.proveedor === "" || isNaN(parseInt(data.proveedor, 10))) {
                    alert("Debe seleccionar un proveedor. Si la lista está vacía, registre un tercero con rol \"Proveedor\" desde Proveedores.");
                    return false;
                }

                 if (!Array.isArray(data.items) || data.items.length === 0) {
                    notify.error("Debe agregar al menos un ítem al gasto.");
                    return false;
                }

                for (let i = 0; i < data.items.length; i++) {
                    const item = data.items[i];

                    if (!item.category) {
                    notify.error(`El ítem #${i + 1} no tiene categoría seleccionada.`);
                    return false;
                    }

                    if (!item.amount || isNaN(item.amount) || item.amount <= 0) {
                    notify.error(`El ítem #${i + 1} debe tener una cantidad válida mayor que 0.`);
                    return false;
                    }

                    if (!item.base || isNaN(item.base) || item.base <= 0) {
                    notify.error(`El ítem #${i + 1} debe tener un valor base válido mayor que 0.`);
                    return false;
                    }
                }

                return true;
            },
            getFechaHoy() {
                const hoy = new Date()
                const yyyy = hoy.getFullYear()
                const mm = String(hoy.getMonth() + 1).padStart(2, "0")
                const dd = String(hoy.getDate()).padStart(2, "0")
                return `${yyyy}-${mm}-${dd}`
            },
            buildGastosFilter() {
                const f = { ...this.filter };
                if (f.dateFrom) {
                    const d = new Date(`${f.dateFrom}T00:00:00`);
                    f.dateFrom = isNaN(d.getTime()) ? "" : String(d.getTime());
                }
                if (f.dateTo) {
                    const d = new Date(`${f.dateTo}T23:59:59.999`);
                    f.dateTo = isNaN(d.getTime()) ? "" : String(d.getTime());
                }
                return f;
            },
            async fetchItems() {
                const offset = (this.page - 1) * this.limit
                if(this.actualPageView === 'gastos'){
                    const {items, totalPages} = await getItems('gastos', offset, this.limit, this.buildGastosFilter())
                    const { items: categories } = await getItems('categorias')
                    const { items: thirdParties } = await getItems('thirdParties',0 ,100 , {label: "Proveedor"})
                    const { items: cajas } = await getItems('cajas', 0, 100, {})
                    this.availableCategories = categories
                    this.availableThirdParties = thirdParties
                    this.setAvailableCajas(cajas)
                    this.items = items
                    this.totalPages = totalPages
                } else if (this.actualPageView === 'thirdParties') {
                    const {items, totalPages} = await getItems('thirdParties', offset, this.limit, this.filter)
                    this.totalPages = totalPages
                    this.items = items
                } else if (this.actualPageView === 'categorias') {
                    const {items, totalPages} = await getItems('categorias', offset, this.limit, this.filter)
                    this.totalPages = totalPages
                    this.items = items
                } else if (this.actualPageView === 'cajas') {
                    const {items, totalPages} = await getItems('cajas', offset, this.limit, this.filter)
                    this.totalPages = totalPages
                    this.items = items
                }
                this.actualItems = this.items
            },
            resetFilters() {
                this.filter = { name: "", id: "", label: "", thirdPartiesID: "", cajaId: "", dateFrom: "", dateTo: "" };
                this.page = 1;
            },
            // Guarda el catálogo de cajas y recuerda la caja por defecto. Si el form de
            // gasto aún no tiene caja elegida, la preselecciona con la caja por defecto.
            setAvailableCajas(cajas) {
                this.availableCajas = cajas || [];
                const def = this.availableCajas.find(c => c.isDefault);
                this.defaultCajaId = def ? def.id : "";
                if (!this.edit && (this.gastosData.cajaId === "" || this.gastosData.cajaId == null)) {
                    this.gastosData.cajaId = this.defaultCajaId;
                }
            },
            formatDate(value) { return formatDateShort(value); },
            formatTotal(value) { return formatCurrencyRAE(value); },
            async fetchById(id) {
                if(this.actualPageView === 'gastos'){
                    const {data} = await getItemsById('gastos', id)
                    this.gastosData = {
                        name: data.name || "",
                        proveedor: data.thirdPartiesID || "",
                        cajaId: data.cajaID || "",
                        date: data.dateAt ? data.dateAt.split('T')[0] : this.getFechaHoy(),
                        info: data.info || "",
                        items: Array.isArray(data.items)
                            ? data.items.map(i => ({
                                id: i.id || "",
                                category: i.categoryID || "",
                                price: i.price*(1+i.iva/100) || "",
                                base: i.price || "",
                                taxData: {
                                iva: i.iva || 0,
                                reteFuente: i.reteFuente || 0,
                                reteIca: i.reteIca || 0,
                                },
                                amount: i.amount || "",
                            }))
                            : [],
                    }
                    this.edit=true;
                    this.actualId=id;
                } else if (this.actualPageView === 'thirdParties') {
                    const {data} = await getItemsById('thirdParties', id)
                    this.proveedorData = {
                        name: data.name,
                        type: data.type,
                        label:data.label,
                        NumberId: data.NumberId,
                        Direction: data.Direction,
                        email: data.email,
                        phone: data.phone,
                        info: data.info}

                    this.actualLabel = (data.label || []).map(lab => {
                     return this.options.find(opt => opt.name === lab) || { name: lab, value: lab.toLowerCase() };
                    });

                    this.edit=true;
                    this.actualId=id;
                } else if (this.actualPageView === 'categorias') {
                    const {data} = await getItemsById('categorias', id)
                    this.categoryData = {
                        name: data.name,
                        code: data.code,
                        info: data.info}

                    this.edit=true;
                    this.actualId=id;
                } else if (this.actualPageView === 'cajas') {
                    const {data} = await getItemsById('cajas', id)
                    this.cajaData = {
                        name: data.name,
                        code: data.code,
                        info: data.info}

                    this.edit=true;
                    this.actualId=id;
                }
            },
            additem() {
                this.gastosData.items.push({
                    category: "",
                    price: "",
                    taxData: {
                        iva: "",
                        reteFuente: "",
                        reteIca: ""
                    },
                    amount: "",
                })
            },
            async save() {
                if (this.actualPageView === 'gastos') {
                    if (!this.validateData(this.gastosData)) return;

                    if (this.gastosData.date === this.getFechaHoy()) {
                        const ahora = new Date()
                        this.gastosData.date = ahora.getTime()
                    } else {
                        const fechaSeleccionada = new Date(this.gastosData.date)
                        fechaSeleccionada.setHours(12, 0, 0, 0)
                        this.gastosData.date = fechaSeleccionada.getTime()
                    }
                    const res = await saveData('gastos', this.gastosData)
                    if(!res){
                        notify.error("Error al guardar los datos del gasto")
                        return
                    }
                    notify.success("Datos guardados correctamente")
                    this.cancel()
                } else if (this.actualPageView === 'thirdParties') {
                    this.proveedorData.label = this.actualLabel
                    .filter(l => l && typeof l === 'object')
                    .map(l => l.name)
                    const res = await saveData('thirdParties', this.proveedorData)
                    if(!res){
                        notify.error("Error al guardar los datos del gasto")
                        return
                    }
                    notify.success("Datos guardados correctamente")
                    this.proveedorData = {
                        name: "",
                        type: "",
                        label: [""],
                        NumberId: "",
                        Direction: "",
                        email: "",
                        phone: "",
                        info: ""
                    }
                } else if (this.actualPageView === 'categorias') {
                    const res = await saveData('categorias', this.categoryData)
                    if(!res){
                        notify.error("Error al guardar los datos del gasto")
                        return
                    }
                    notify.success("Datos guardados correctamente")
                    this.categoryData = {
                        name: "",
                        code: "",
                        info: ""
                    }
                } else if (this.actualPageView === 'cajas') {
                    const res = await saveData('cajas', this.cajaData)
                    if(!res){
                        notify.error("Error al guardar los datos de la caja")
                        return
                    }
                    notify.success("Datos guardados correctamente")
                    this.cajaData = {
                        name: "",
                        code: "",
                        info: ""
                    }
                }
                this.fetchItems()
            },
            async cancel() {
                const defaults = this.$options.data.call(this);

                switch (this.actualPageView) {
                    case 'gastos':
                    this.gastosData = { ...defaults.gastosData };
                    this.gastosData.cajaId = this.defaultCajaId;
                    break;
                    case 'thirdParties':
                    this.proveedorData = { ...defaults.proveedorData };
                    this.actualLabel = [""];
                    break;
                    case 'categorias':
                    this.categoryData = { ...defaults.categoryData };
                    break;
                    case 'cajas':
                    this.cajaData = { ...defaults.cajaData };
                    break;
                }
                this.edit=false;
                this.actualId="";
            },
            async editElement(actualId){
                const tipo = this.actualPageView;
                let data = {};

                switch (tipo) {
                    case 'gastos':
                    data = this.gastosData;
                    break;
                    case 'thirdParties':
                    this.proveedorData.label = this.actualLabel.filter(l => l && typeof l === 'object').map(l => l.name)
                    data = this.proveedorData;
                    break;
                    case 'categorias':
                    data = this.categoryData;
                    break;
                    case 'cajas':
                    data = this.cajaData;
                    break;
                    default:
                    console.error('Tipo no reconocido:', tipo);
                    return;
                }
                if (tipo === 'gastos' && !this.validateData(data)) return;

                if (tipo === 'gastos' && data.date === this.getFechaHoy()) {
                        const ahora = new Date()
                        data.date = ahora.getTime()
                    } else {
                        const fechaSeleccionada = new Date(data.date)
                        fechaSeleccionada.setHours(12, 0, 0, 0)
                        data.date = fechaSeleccionada.getTime()
                    }

                try {
                    const res = await editData(tipo, data, actualId);
                    if (!res || res === "") {
                        notify.error("Error al guardar los datos del gasto");
                    } else {
                        notify.success("Datos guardados correctamente");
                        console.log('Elemento editado con éxito:', res);
                    }
                } catch (error) {
                    console.error('Error al editar elemento:', error);
                }
                this.cancel()
                this.fetchItems()
            },
            async nextPage() {
                if (this.page < this.totalPages) {
                    this.page++
                    this.fetchItems()
                }
            },
            async prevPage() {
                if (this.page > 1) {
                    this.page--
                    this.fetchItems()
                }
            },
            /**
             * Punto unico de cambio de pestana. Delega en los metodos que ya
             * existian para no duplicar el reseteo de filtros ni la recarga.
             */
            setView(value) {
                const handlers = {
                    gastos: this.gastosAdmin,
                    thirdParties: this.proveedorAdmin,
                    categorias: this.categoryAdmin,
                    cajas: this.cajasAdmin,
                };
                if (handlers[value]) handlers[value]();
            },
            /** El submit del formulario activo: alta o edicion segun el estado. */
            submitForm() {
                if (this.edit) {
                    this.editElement(this.actualId);
                    return;
                }
                this.save();
            },
            goToPage(page) {
                this.page = page;
                this.fetchItems();
            },
            categoryAdmin() {
                this.actualPageView = 'categorias'
                this.category = true
                this.cajaView = false
                this.proveedor = false
                this.gastos = false
                this.resetFilters()
                this.fetchItems()
                this.cancel()
            },
            cajasAdmin() {
                this.actualPageView = 'cajas'
                this.category = false
                this.cajaView = true
                this.proveedor = false
                this.gastos = false
                this.resetFilters()
                this.fetchItems()
                this.cancel()
            },
            proveedorAdmin() {
                this.actualPageView = 'thirdParties'
                this.category = false
                this.cajaView = false
                this.proveedor = true
                this.gastos = false
                this.resetFilters()
                this.fetchItems()
                this.cancel()
            },
            gastosAdmin() {
                this.actualPageView = 'gastos'
                this.category = false
                this.cajaView = false
                this.proveedor = false
                this.gastos = true
                this.resetFilters()
                this.fetchItems()
                this.cancel()
            },
        },
        mounted() {
            this.fetchItems()
        }
    }
</script>

<style scoped>
/* Ficha a la izquierda, listado a la derecha. El formulario de gasto es
   alto (lleva itemCalculate), asi que no se usa `.adm-grid-2`. */
.gastos__layout {
    display: grid;
    grid-template-columns: minmax(340px, 460px) minmax(0, 1fr);
    gap: var(--adm-gap-lg);
    align-items: start;
}

@media (max-width: 1100px) {
    .gastos__layout { grid-template-columns: minmax(0, 1fr); }
}

.gastos__form {
    display: flex;
    flex-direction: column;
    gap: var(--adm-gap);
}

.gastos__form-actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--adm-gap-sm);
}

.gastos__multi {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}

.gastos__multi-label {
    font-family: var(--font-body);
    font-size: var(--adm-font-sm);
    font-weight: 600;
    color: var(--color-text-strong);
}

.gastos__items {
    display: flex;
    flex-direction: column;
    gap: var(--adm-gap-sm);
    align-items: flex-start;
    padding: var(--adm-gap);
    background-color: var(--adm-surface-alt);
    border-radius: var(--adm-radius-sm);
}

.gastos__item-row {
    display: flex;
    align-items: flex-start;
    gap: var(--adm-gap-sm);
    width: 100%;
}

.gastos__item-row > :first-child {
    flex: 1;
    min-width: 0;
}

.gastos__total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    padding: 0.6rem 0.8rem;
    background-color: var(--adm-info-bg);
    border-radius: var(--adm-radius-sm);
    font-family: var(--font-body);
    font-size: var(--adm-font-base);
}

.gastos__total strong {
    font-size: 1.05rem;
    color: var(--color-title);
}

/* --- Filtros --- */
.gastos__filter-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
    gap: var(--adm-gap);
    align-items: end;
}

.gastos__filter-row--advanced { margin-top: var(--adm-gap); }

.gastos__filter-toggle { display: flex; }

/* --- Listado --- */
.gastos__list {
    display: flex;
    flex-direction: column;
    gap: var(--adm-gap-sm);
}

.gastos__card {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--adm-gap);
    padding: 0.8rem;
    border: 1px solid var(--adm-border);
    border-radius: var(--adm-radius-sm);
    background-color: var(--adm-surface);
    transition: border-color 0.15s ease;
}

.gastos__card:hover { border-color: var(--adm-border-strong); }

.gastos__card-body { min-width: 0; flex: 1; }

.gastos__card-head {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.gastos__card-id {
    font-size: 0.75rem;
    color: var(--color-text);
}

.gastos__card-name {
    margin: 0;
    font-family: var(--font-subtitle);
    font-size: var(--adm-font-base);
    font-weight: 700;
    color: var(--color-title);
}

.gastos__card-info { margin: 0.25rem 0 0 0; }

.gastos__card-meta {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: 0.35rem var(--adm-gap);
    margin: 0.6rem 0 0 0;
}

.gastos__card-meta dt {
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--color-text);
}

.gastos__card-meta dd {
    margin: 0;
    font-size: var(--adm-font-sm);
    color: var(--color-text-strong);
}

.gastos__card-total {
    font-weight: 700;
    color: var(--color-title);
}
</style>
